// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__0nYf3","modal":"Modal_modal__H2ffP","slide-down":"Modal_slide-down__aXHi3"};